module.exports = __webpack_public_path__ + "static/media/katrineholm_1.372b67b4.jpg";